import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import MasterFilterService2 from '@app/main/master-filter/master-filter.service2';
import { isEmpty, isNil } from 'lodash';
import { ToastModule } from 'primeng/toast';
import { Subscription } from 'rxjs';

interface IOption {
    id: number;
    value: string;
    label: string;
    selected?: boolean;
    children?: IOption[];
    parentId?: number;
    order?: number;
}

interface ISelectionChangedArgs {
    estateTypeIds: number[];
    estateCategoryIds: number[];
}

@Component({
    selector: 'app-cascade-selection',
    templateUrl: './cascade-selection.component.html',
    styleUrls: ['./cascade-selection.component.less'],
    standalone: false,
})
class CascadeSelectionComponent implements OnInit {
    @Input() options: IOption[] = [];

    @Input() isFilterOpen: boolean = false;

    @Input() firstLevelTitle: string = 'First Level';

    @Output() selectionChange: EventEmitter<ISelectionChangedArgs> = new EventEmitter<ISelectionChangedArgs>();

    firstLevelOptions: IOption[];

    selectedFirstLevel: IOption;

    secondLevelOptions: IOption[];

    selectedSecondLevelOptions: IOption[] = [];

    estateTypesOptions: IOption[] = [];

    selectedEstateTypesOptions: IOption[] = [];

    form: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private masterFilterService: MasterFilterService2,
    ) {
    }

    get firstLevelFormControl(): FormControl {
        return this.form.get('firstLevelOption') as FormControl;
    }

    get secondLevelFormControl(): FormControl {
        return this.form.get('secondLevelOptions') as FormControl;
    }

    get estateTypesOptionsFormControl(): FormControl {
        return this.form.get('estateTypesOptions') as FormControl;
    }

    ngOnInit(): void {

        this.form = this.formBuilder.group({
            firstLevelOption: [],
            secondLevelOptions: [[]],
            estateTypesOptions: [[]],
        });

        this.firstLevelFormControl.valueChanges.subscribe((value: IOption) => {
            this.masterFilterService.updateSelectedEstateCategoryFirstLevel(value);
        });

        this.secondLevelFormControl.valueChanges.subscribe((values: IOption[]) => {
            this.masterFilterService.updateSelectedEstateCategorySecondLevel(values);
        });

        this.estateTypesOptionsFormControl.valueChanges.subscribe((values: IOption[]) => {
            this.masterFilterService.updateSelectedEstateTypes(values);
        });

        this.masterFilterService
            .getEstateCategoriesFirstLevel()
            .subscribe((result) => {
                this.firstLevelOptions = result;
            });

        this.masterFilterService
            .getSelectedEstateCategoryFirstLevel()
            .subscribe((result) => {
                this.selectedFirstLevel = result;
            });

        this.masterFilterService
            .getEstateCategoriesSecondLevel()
            .subscribe((result) => {
                if (!isNil(result)) {
                    this.secondLevelOptions = result
                        ? result
                        : [];
                }
                this.secondLevelFormControl.setValue([]);
            });

        this.masterFilterService
            .getSelectedEstateCategorySecondLevel()
            .subscribe((result) => {
                if (!isNil(result)) {
                    this.selectedSecondLevelOptions = result;
                }
            });

        this.masterFilterService
            .getEstateTypes()
            .subscribe((result) => {

                if (!isNil(result)) {

                    this.estateTypesOptions = result
                        ? result
                        : [];

                    const newSelectedEstateTypes = this.selectedEstateTypesOptions
                        .filter((opt) => this.estateTypesOptions
                            .some((o) => o.id === opt.id));
                    this.estateTypesOptionsFormControl.setValue(newSelectedEstateTypes);

                }
            });

        this.masterFilterService
            .getSelectedEstateTypes()
            .subscribe((result) => {
                if (!isNil(result)) {
                    this.selectedEstateTypesOptions = result;
                }
            });
    }

    resetForm() {
        this.form.reset();
    }

    onEstateTypeChange(event: any) {
        console.log('onEstateTypeChange', event);
    }

    onSubmit() {
        const { estateTypesOptions, firstLevelOption, secondLevelOptions } = this.form.value;
        const estateTypeIds = estateTypesOptions?.map(({ id }) => id) ?? [];

        const estateCategoryIds = isEmpty(secondLevelOptions)
            ? isNil(firstLevelOption)
                ? []
                : [firstLevelOption.id]
            : secondLevelOptions.map(({ id }) => id);

        this.selectionChange.emit({
            estateTypeIds,
            estateCategoryIds,
        });
    }

}

export default CascadeSelectionComponent;
export type { IOption, ISelectionChangedArgs };
